export default function isDeletedNodeSelected({ state, props, path }) {
  let selectNodePath = state.get('node.selectedNode.path')

  if (selectNodePath === state.get('node.deleteNode')) {
    selectNodePath = selectNodePath.split('.')
    selectNodePath.splice(selectNodePath.length - 2, 2)
    return path.true({ path: selectNodePath.join('.') })
  }

  if (
    selectNodePath &&
    selectNodePath.startsWith(state.get('node.deleteNode'))
  ) {
    return path.true()
  }

  return path.false()
}



// WEBPACK FOOTER //
// ./src/modules/Node/actions/isDeletedNodeSelected.js